import { render, staticRenderFns } from "./TabSellByAddition.vue?vue&type=template&id=74dedd84&"
import script from "./TabSellByAddition.vue?vue&type=script&lang=js&"
export * from "./TabSellByAddition.vue?vue&type=script&lang=js&"
import style0 from "./TabSellByAddition.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports